var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteAlt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1628 22C21.282 22 23 20.278 23 18.1538V15.0769C23 12.9528 21.282 11.2308 19.1628 11.2308H14.814V9.151C14.814 6.05128 17.3209 3.53846 20.4134 3.53846C20.8373 3.53846 21.1809 3.19406 21.1809 2.76923C21.1809 2.3444 20.8373 2 20.4134 2C16.4732 2 13.2791 5.20161 13.2791 9.151V18.1538C13.2791 20.278 14.997 22 17.1163 22H19.1628Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88372 22C9.00295 22 10.7209 20.278 10.7209 18.1538V15.0769C10.7209 12.9528 9.00295 11.2308 6.88372 11.2308H2.53488V9.151C2.53488 6.05128 5.04186 3.53846 8.13437 3.53846C8.55821 3.53846 8.90181 3.19406 8.90181 2.76923C8.90181 2.3444 8.55821 2 8.13437 2C4.19417 2 1 5.20161 1 9.151V18.1538C1 20.278 2.71798 22 4.83721 22H6.88372Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteAlt3);
export default __webpack_public_path__ + "static/media/quote-alt-3.3d76e461133b54e47d981ea5f5cefee6.svg";
export { ForwardRef as ReactComponent };